import {
    FrontendExperimentsResponse,
    Identifiers
} from "@atlassian/feature-gate-node-client-bootstrapper";

export type FeatureGatesBootstrapValues = FrontendExperimentsResponse & {
    identifiers: Identifiers;
};

declare global {
    interface Window {
        featureGateBootstrapValues: FeatureGatesBootstrapValues;
    }
}

export enum StatsigFeatureGateKey {
    BXPSU_2854_CONFLUENCE_PUBLIC_LINK = "bxpsu-2854_confluence_public_link", // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/gates/bxpsu-2854_confluence_public_link
    ST_34831_ENTERPRISE_SALES_FORM_EN_DESC = "st_34831_enterprise_sales_form_en_desc" // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/gates/st_34831_enterprise_sales_form_en_desc
}

export enum StatsigExperimentKey {
    WAC_SIGNUP_UPGRADE_PATH = "wac_signup_upgrade_path", // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/wac_signup_upgrade_path
    JFIND_COMPANY_EXPAND = "jfind-company-expand", // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/jfind-company-expand
    JFIND_CONTACT_EXPAND = "jfind-contact-expand", // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/jfind-contact-expand
    JFIND_SANDBOX_M1_5 = "jfind-sandbox-m1-5", // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/jfind-sandbox-m1-5
    JFIND_TRANSPARENT_TEMPLATE_FOR_ALL_TEAMS = "jfind-transparent-template-for-all-teams", // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/jfind-transparent-template-for-all-teams
    JFIND_ANIMATED_PROVISIONING_BRAND_REFRESH = "jfind-animated-provisioning-brand-refresh", // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/jfind-animated-provisioning-brand-refresh
    JFIND_PAID_GET_USERS_BACK_TO_PRODUCT = "jfind-get-users-back-to-product-for-paid", // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/jfind-get-users-back-to-product-for-paid/setup
    JFIND_REDIRECT_TO_PRODUCT = "jfind-redirect-jira-users-to-product" //https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/jfind-redirect-jira-users-to-product/setup
}

// Recommend to prefix cohort names with experiment ticket (ex. expcen-1234_variation-1)
export enum StatsigExperimentCohort {
    UNEXPECTED_FAILURE = "unexpected_failure",
    NOT_ENROLLED = "not_enrolled",
    WAC_SIGNUP_UPGRADE_PATH_TEST = "test",
    JFIND_CONTACT_EXPAND_CONTROL = "control",
    JFIND_CONTACT_EXPAND_VARIANT = "jfind-contact-expand",
    JFIND_COMPANY_EXPAND_CONTROL = "control",
    JFIND_COMPANY_EXPAND_VARIANT = "jfind-company-expand",
    JFIND_TRANSPARENT_TEMPLATE_FOR_ALL_TEAMS_CONTROL = "control",
    JFIND_TRANSPARENT_TEMPLATE_FOR_ALL_TEAMS_VARIANT = "variant",
    JFIND_REDIRECT_TO_PRODUCT_CONTROL = "control",
    JFIND_REDIRECT_TO_PRODUCT_VARIANT = "variant",
    JFIND_PAID_GET_USERS_BACK_TO_PRODUCT_CONTROL = "control",
    JFIND_PAID_GET_USERS_BACK_TO_PRODUCT_VARIANT = "variation"
}
